import { useEmbarcacaoThrusters } from "../../../../hooks/use-embarcacao-thrusters";
import { formatDetailCell, latestAtualizacao } from "../../../detail-format/detail-format";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  THRUSTERS_COLUMNS,
  THRUSTERS_EMPTY_STATE,
  THRUSTERS_ID,
  THRUSTERS_LOADING_MESSAGE,
  THRUSTERS_TABLE_MIN_WIDTH,
  THRUSTERS_TEST_ID,
  THRUSTERS_TITLE,
} from "./thrusters-section.constants";

/**
 * Seção Thrusters do detalhamento da embarcação: uma linha da tabela por thruster (RN002), na ordem da fonte, somente
 * para leitura e sem ordenação, paginação, filtro nem ajuste de colunas.
 */
export function useThrustersSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, thrusters, errorMessage, reload } = useEmbarcacaoThrusters(embarcacaoId);

  return {
    id: THRUSTERS_ID,
    title: THRUSTERS_TITLE,
    testId: THRUSTERS_TEST_ID,
    status,
    errorMessage,
    loadingMessage: THRUSTERS_LOADING_MESSAGE,
    emptyContent: THRUSTERS_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem registros.
    ultimaAtualizacao: thrusters
      ? latestAtualizacao(
          thrusters.flatMap((row) => [row.ultimaAtualizacao, row.atualizacaoThrusters]),
        )
      : undefined,
    tabela: {
      title: THRUSTERS_TITLE,
      testId: `${THRUSTERS_TEST_ID}-table`,
      minWidth: THRUSTERS_TABLE_MIN_WIDTH,
      columns: THRUSTERS_COLUMNS.map(({ field, header }) => ({ field, header })),
      rows: (thrusters ?? []).map(
        (thruster, key): { key: number } & Record<string, string | number> => ({
          key,
          ...Object.fromEntries(
            THRUSTERS_COLUMNS.map(({ field, format }) => [
              field,
              formatDetailCell(thruster[field], format),
            ]),
          ),
        }),
      ),
    },
  };
}
